module.exports = __webpack_public_path__ + "static/img/simei.b83f0f75.png";